<template>
  <v-container fluid class="pa-0">
    <v-tabs v-model="tab">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab>Air ({{ airGroups.length }})</v-tab>
      <v-tab>Sea ({{ seaGroups.length }})</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <div style="overflow-x: auto">
          <v-data-table
            mobile-breakpoint="0"
            :headers="airHeaders"
            :items="airGroups"
            :items-per-page="15"
            :options.sync="airOptions"
            class="elevation-0"
          >
            <template v-slot:header>
              <tr>
                <th v-for="(header, idx) in airHeaders" :key="`header-${idx}`">
                  <v-text-field
                    dense
                    class="ma-2"
                    rounded
                    v-model="filter[header.value]"
                    placeholder="filter"
                    solo-inverted
                    hide-details
                    flat
                  ></v-text-field>
                </th>
              </tr>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <a
                @click="
                  $router.push({
                    name: 'ShipmentGroupUpdate',
                    params: { id: item.id },
                  })
                "
                >{{ item.id }}</a
              >
            </template>
            <template v-slot:[`item.shipmentDate`]="{ item }">
              {{ convertToDate(item.shipmentDate, false) }}
            </template>
            <template v-slot:[`item.createdBy`]="{ item }">
              {{ getUserName(item.createdBy) }}
            </template>
            <template v-slot:[`item.statusId`]="{ item }">
              <div class="d-flex" style="width: 200px">
                <v-autocomplete
                  rounded
                  outlined
                  dense
                  hide-details
                  v-model="item.statusId"
                  label="Status"
                  :items="statuses"
                  item-text="displayName"
                  item-value="id"
                ></v-autocomplete>
                <v-btn
                  icon
                  color="primary"
                  @click="updateShipmentGroup(item)"
                  :loading="selectedId == item.id"
                  ><i class="fa-solid fa-floppy-disk"></i
                ></v-btn>
              </div>
            </template>
          </v-data-table></div
      ></v-tab-item>
      <v-tab-item
        ><div style="overflow-x: auto">
          <v-data-table
            mobile-breakpoint="0"
            :headers="seaHeaders"
            :items="seaGroups"
            :items-per-page="15"
            :options.sync="seaOptions"
            class="elevation-0"
          >
            <template v-slot:header>
              <tr>
                <th v-for="(header, idx) in seaHeaders" :key="`header-${idx}`">
                  <v-text-field
                    dense
                    class="ma-2"
                    rounded
                    v-model="filter[header.value]"
                    placeholder="filter"
                    solo-inverted
                    hide-details
                    flat
                  ></v-text-field>
                </th>
              </tr>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <a
                @click="
                  $router.push({
                    name: 'ShipmentGroupUpdate',
                    params: { id: item.id },
                  })
                "
                >{{ item.id }}</a
              >
            </template>
            <template v-slot:[`item.shipmentDate`]="{ item }">
              {{ convertToDate(item.shipmentDate, false) }}
            </template>
            <template v-slot:[`item.createdBy`]="{ item }">
              {{ getUserName(item.createdBy) }}
            </template>
            <template v-slot:[`item.statusId`]="{ item }">
              <!-- {{ getOptionName(item.statusId) }} -->
              <div class="d-flex" style="width: 200px">
                <v-autocomplete
                  rounded
                  outlined
                  dense
                  hide-details
                  v-model="item.statusId"
                  label="Status"
                  :items="statuses"
                  item-text="displayName"
                  item-value="id"
                ></v-autocomplete>
                <v-btn
                  icon
                  color="primary"
                  @click="updateShipmentGroup(item)"
                  :loading="selectedId == item.id"
                  ><i class="fa-solid fa-floppy-disk"></i
                ></v-btn>
              </div>
            </template>
            ></v-data-table
          >
        </div></v-tab-item
      >
    </v-tabs-items>
  </v-container>
</template>
<script>
import eventBus from "@/js/event-bus.js";
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service";
import { ShipmentType } from "@/js/enum";
export default {
  name: "ShipmentGroupList",
  mixins: [generalMixin],
  data() {
    return {
      dialog: false,
      shipmentDate: null,
      selectedId: -1,
      airHeaders: [
        {
          text: "Id",
          align: "start",
          sortable: false,
          value: "id",
          width: 100,
        },
        { text: "Shipment Date", value: "shipmentDate", width: 200 },
        { text: "Total Boxes", value: "totalBox", width: 150 },
        { text: "Total Weight", value: "totalWeight", width: 150 },
        { text: "Total Value", value: "totalValue", width: 150 },
        { text: "Status", value: "statusId", width: 100 },
        { text: "Created By", value: "createdBy", width: 150 },
      ],
      seaHeaders: [
        {
          text: "Id",
          align: "start",
          sortable: false,
          value: "id",
          width: 100,
        },
        { text: "Shipment Date", value: "shipmentDate", width: 200 },
        { text: "Total Boxes", value: "totalBox", width: 150 },
        { text: "Total Pallet", value: "totalPallet", width: 150 },
        { text: "Total Value", value: "totalValue", width: 150 },
        { text: "Status", value: "statusId", width: 100 },
        { text: "Created By", value: "createdBy", width: 150 },
      ],
    };
  },
  mounted: function () {
    this.$store.dispatch("getShipmentGroups");
    eventBus.$on("generateCsv", this.generateCsv);
  },
  computed: {
    tab: {
      get() {
        return this.$store.getters["interactStore/stockTab"];
      },
      set(val) {
        this.$store.commit("interactStore/setStockTab", val);
      },
    },
    filteredGroups() {
      let shipmentGroups = this.shipmentGroups;

      let headers = this.tab == 0 ? this.airHeaders : this.seaHeaders;
      for (let key in this.filter) {
        let searchStr = this.filter[key].trim().toLowerCase();
        let header = headers.find((header) => header.value == key);
        if (searchStr && searchStr.length) {
          shipmentGroups = shipmentGroups.filter((e) => {
            let str = this.getDataText(header, e);
            return str
              .toString()
              .trim()
              .toLowerCase()
              .includes(this.filter[key].toLowerCase());
          });
        }
      }
      return shipmentGroups;
    },
    airGroups() {
      let air = this.getIdByEnum(ShipmentType.Air);
      return this.filteredGroups.filter((e) => e.typeId == air);
    },
    seaGroups() {
      let sea = this.getIdByEnum(ShipmentType.Sea);
      return this.filteredGroups.filter((e) => e.typeId == sea);
    },
    shipmentGroups() {
      return this.$store.getters["shipmentGroups"];
    },
    statuses() {
      if (
        this.$store.getters["dropdownToOptions"] &&
        this.$store.getters["dropdownToOptions"]["shipmentGroupStatus"]
      )
        return this.$store.getters["dropdownToOptions"]["shipmentGroupStatus"]
          .options;
      return [];
    },
    airOptions: {
      get() {
        return this.$store.getters["interactStore/airGroupOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setAirGroupOptions", val);
      },
    },
    seaOptions: {
      get() {
        return this.$store.getters["interactStore/seaGroupOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setSeaGroupOptions", val);
      },
    },
    filter: {
      get() {
        return this.$store.getters["interactStore/shipmentGroupFilter"];
      },
      set(val) {
        this.$store.commit("interactStore/setShipmentGroupFilter", val);
      },
    },
  },
  methods: {
    addShipmentGroup() {
      let shipmentGroupInfo = {};
      shipmentGroupInfo.shipmentDate = this.shipmentDate;
      backendService.addShipmentGroup(shipmentGroupInfo).then((response) => {
        this.dialog = false;
        shipmentGroupInfo.id = response.data;
        shipmentGroupInfo.totalWeight = 0;
        shipmentGroupInfo.totalBox = 0;
        shipmentGroupInfo.totalValue = 0;
        this.shipmentGroups.push(shipmentGroupInfo);
      });
    },
    generateCsv() {
      let groups = this.airGroups;
      let headerStr =
        "Id;Shipment Date;Total Boxes;Total Weight;Total Value;Status";
      if (this.tab != 0) {
        groups = this.seaGroups;
        headerStr =
          "Id;Shipment Date;Total Boxes;Total Pallet;Total Value;Status";
      }
      let csvContent = "";
      csvContent += headerStr + "\r\n";

      for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        let rowStr = `${group.id};${this.convertToDate(
          group.shipmentDate,
          false
        )};${group.totalBox};${
          this.tab == 0 ? group.totalWeight : group.totalPallet
        };${group.totalValue};${this.getOptionName(group.statusId)}`;
        csvContent += rowStr + "\r\n";
      }
      let blob = new Blob([csvContent], { type: "text/plain" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `${this.tab == 0 ? "air" : "sea"}-shipment-group-list.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDataText(header, group) {
      if (header == null || !header.value) {
        return "";
      }
      if (header.value == "id") {
        return group.id.toString();
      } else if (header.value == "shipmentDate") {
        return this.convertToDate(group.shipmentDate, false);
      } else if (header.value == "totalBox") {
        return group.totalBox.toString();
      } else if (header.value == "totalWeight") {
        return group.totalWeight.toString();
      } else if (header.value == "totalPallet") {
        return group.totalPallet.toString();
      } else if (header.value == "totalValue") {
        return group.totalValue.toString();
      } else if (header.value == "statusId") {
        return this.getOptionName(group.statusId);
      } else if (header.value == "typeId") {
        return this.getOptionName(group.typeId);
      } else {
        return "";
      }
    },
    updateShipmentGroup(shipmentGroup) {
      this.selectedId = shipmentGroup.id;
      backendService.updateShipmentGroup(shipmentGroup).then(() => {
        this.$store.commit("updateShipmentGroup", shipmentGroup);
        this.timer(1000).then(() => {
          this.selectedId = -1;
          this.$store.dispatch("getShipments");
          eventBus.$emit(
            "setSnackbar",
            "Successfully update shipment group",
            "success",
            true
          );
        });
      });
    },
  },
  destroyed: function () {
    eventBus.$off("generateCsv");
  },
};
</script>
